<template>
    <form class="step-stage-hito-vida-form form-horizontal" @submit.prevent="submit()">
        <div class="form-group"  :class="{'has-error': errors['name']}">
            <label for="name" class="col-sm-2 control-label">Nombre del Paso</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="name" v-model="data.name" >
                 <div class="help-block" v-for="e in errors['name']">{{e}}</div>
            </div>
        </div>
        <div v-if="data.components.length >0" class="form-group">
            <label for="" class="col-sm-2 control-label">Componentes</label>
            <div class="col-sm-10">
                <table class="table">
                    <thead>
                        <th>Nro</th>
                        <th>Titulo</th>
                        <th>Tipo</th>
                        <th>Acciones</th>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in data.components" :key="index">
                            <td>{{index +1}}</td>
                            <td v-bind:title="item.title"> {{item.title != '' ? item.title.substring(0,50)+' ...' : '' }} </td>
                            <td>{{item.name}}</td>
                            <td>
                                <a href="#"  @click.prevent="upComponent(index)" title="Subir"><i class="material-icons">arrow_upward</i></a>
                                <a href="#"  @click.prevent="downComponent(index)" title="Bajar"><i class="material-icons">arrow_downward</i></a>
                                <a href="#" @click.prevent="onEditComponent(index)"><i class="material-icons">create</i></a>
                                <a href="#" @click.prevent="deleteComponent(index)" ><i class="material-icons">delete</i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['componentType']}">
            <label for="" class="col-sm-2 control-label">{{editComponent?'Tipo Componente':'Nuevo Componente'}}</label>
            <div class="col-sm-10"  >
                <el-select  placeholder="Seleccione Tipo de Componente" v-model="component.typeId"   id="componentType" style="width:60%" :disabled="editComponent">
                    <el-option v-for="i in typecomponents" 
                        :key="i.id" 
                        :label="i.name"
                        :value="i.id" 
                     >
                    </el-option>
                </el-select>
               <div class="help-block" v-for="e in errors['componentType']">{{e}}</div>
            </div>
        </div>
        <div  v-show="component.typeId > 0" class="border">
            <div v-if="component.typeId == 2" class="form-group" :class="{'has-error': errors['title']}">
                <label for="" class="col-sm-2 control-label">Titulo de Tarjeta</label>
                <div class="col-sm-10" >
                    <input type="text" class="form-control" id="title"  v-model="component.title" >
                    <div class="help-block" v-for="e in errors['title']">{{e}}</div>
                </div>
            </div>
            <div v-if="component.typeId == 2" class="form-group">
                <label for="" class="col-sm-2 control-label">{{ editSubComponent ?'Tipo Componente':'Nuevo Componente'}}</label>
                <div class="col-sm-10">
                    <el-select  placeholder="Seleccione Tipo de Componente" v-model="subcomponent.typeId"   id="typecomponent2" style="width:60%" :disabled="editSubComponent" @change="cleaEditor">
                        <el-option v-for="i in typecomponents" 
                            :key="i.id" 
                            :label="i.name"
                            :value="i.id" 
                        >
                        </el-option>
                    </el-select>    
                </div>
            </div>
            <div v-if="component.typeId == 2 && subcomponent.typeId ==2" class="form-group" :class="{'has-error': errors['subcomponenttitle']}">
                <label for="" class="col-sm-2 control-label">Titulo de Sub Tarjeta</label>
                <div class="col-sm-10" >
                    <input type="text" class="form-control" id="subcomponenttitle"  v-model="subcomponent.title" >
                    <div class="help-block" v-for="e in errors['subcomponenttitle']">{{e}}</div>
                </div>
            </div>
            <div v-if="component.components " class="form-group">
                <label for="" class="col-sm-2 control-label">Componentes Tarjeta</label>
                <div class="col-sm-10">
                    <table class="table">
                        <thead>
                            <th>Nro</th>
                            <th>Titulo</th>
                            <th>Tipo</th>
                            <th>Acciones</th>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in component.components" :key="index">
                                <td>{{index +1}}</td>
                                <td v-bind:title="item.title"> {{item.title != '' ? item.title.substring(0,50)+' ...' : '' }} </td>
                                <td>{{item.name}}</td>
                                <td>{{item.name}}</td>
                                <td>
                                    <a href="#"  @click.prevent="upSubComponent(index)" title="Subir"><i class="material-icons">arrow_upward</i></a>
                                <a href="#"  @click.prevent="downSubComponent(index)" title="Bajar"><i class="material-icons">arrow_downward</i></a>
                                    <a href="#" @click.prevent="onEditSubComponent(index)"><i class="material-icons">create</i></a>
                                    <a href="#" @click.prevent="deleteSubComponent(index)"><i class="material-icons">delete</i></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-show="component.typeId >0" class="form-group">
                <div class="col-sm-offset-2 col-sm-10 ">
                   <a v-show="component.typeId == 1 ||(component.typeId ==2 && subcomponent.typeId > 0)" href="#"  @click.prevent="addElement('info')" >Add Link <img src="images/bullet-info.svg" /> </a> &nbsp;
                    <a v-show="component.typeId ==2 && subcomponent.typeId > 0"  href="#"  @click.prevent="addElement('doc')" >Add Link File <i class="material-icons">description</i> </a> &nbsp;
                
                </div>
            </div>
            <div v-show="component.typeId ==1 || (component.typeId ==2 && subcomponent.typeId > 0)  " class="form-group" :class="{'has-error': errors['description']}">
                <div class="col-sm-offset-2 col-sm-10">
                    <editor-hito-vida id="description" v-model="description" ></editor-hito-vida>
                    <div class="help-block" v-for="e in errors['description']">{{e}}</div>
                </div>
            </div>
            <div v-show="subcomponent.title.length >0" class="form-group">
                <label for="" class="col-sm-2">Previsualización</label>
                <div class="col-sm-10">
                    <div class="accordion-page">
                        <div class="card stage-block">
                            <div class="sub-card">
                                <div class="card-body ">
                                    <div class="sub-card">
                                        <a href="javascript:void(0);" data-level="3" data-toggle="collapse" data-target="#collapseinnerdeeper-One" aria-expanded="false" aria-controls="collapseinnerdeeper-One" class="btn-link collapsed">
                                        
                                            <div id="headingtwo" class="card-header">
                                                <img class="icon" src="images/document.svg">
                                                <h3 class="question">{{subcomponent.title}}</h3>
                                                <span class="more">&lsaquo;</span>
                                            </div>
                                        </a>
                                        <div id="collapseinnerdeeper-One" data-level="3" aria-labelledby="headingtwo" data-parent="#accordionpage" class="collapseinnerdeeper collapse" aria-expanded="false" style="">
                                            <div class="card-body">
                                                <span v-html="setFinalText(description)"></span>
                                            </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                    <a href="#" @click.prevent="cancelComponent"  class="btn btn-default">Cancelar</a>
                    <a v-if="(component.typeId == 1 ) ||  (component.typeId == 2 && component.components.length >0 && subcomponent.typeId =='') " href="#" @click.prevent="addComponent('comp')" title="Agregar Componente"  class="btn btn-primary">
                        {{ editComponent?'Actualizar Componente':'Agregar Componente'}}
                    </a>
                    <a v-if="(component.typeId == 2 && subcomponent.typeId > 0 && component.components.length == 0) || (component.typeId == 2 && component.components.length >0 && subcomponent.typeId > 0)  " href="#" class="btn btn-primary" @click.prevent="addComponent('subcomp')"> 
                        {{ editSubComponent ? 'Actualizar Componente la Tarjeta':'Agregar Componente la Tarjeta'}}
                    </a>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-sm-2 control-label">¿Activo?</label>
            <div class="col-sm-10">
                <el-switch  on-text="SI" off-text="NO" v-model="data.active"></el-switch>
            </div>
        </div>
        <div class="form-group">
            <label class="col-sm-2 control-label">Previsualización</label>
            <div class="col-sm-10">
                <div class="life-stages " v-if="data.name.length > 0 || data.components.length>0">
                    <div class="row">
                        <div class="col-md-12 col-sm-12 col-xs-12">
                            <div id="accordionpage" class="accordion accordion-page">
                                <div class="card stage-block">
                                    <a href="javascript:void(0);" data-level="1" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" class="btn-link ">
                                        <div id="headingtwo" class="card-header">
                                            <span class="bullet">{{data.order}}</span><h2 class="beneficiaries">{{data.name}}</h2><span class="know-more">Conocer m&aacute;s</span>
                                        </div>
                                    </a>
                                    <div id="collapseOne" data-level="1" aria-labelledby="headingtwo" data-parent="#accordionpage" class="collapse in" aria-expanded="true" style="height: 0px;">
                                        <div class="card-body content">
 
                                            <template v-for="(item,index) in data.components">
                                                <span v-if="item.typeId == 1" v-html="item.content" :key="index"></span>
                                                 <div v-else class="sub-card" :key="index" >
                                                    <a href="javascript:void(0);" data-toggle="collapse" :data-target="'#collapseinner-' + index" aria-expanded="false" :aria-controls="'collapseinner-' + index" class="btn-link collapsed" >
                                                        <div class="card-header">
                                                            <h3 class="question">{{item.title}}</h3>
                                                            <span class="more">&lsaquo;</span>   
                                                        </div>
                                                    </a>
                                                    <div :id="'collapseinner-' + index" data-level="2" aria-labelledby="headingtwo" data-parent="#accordionpage" class="collapseinner collapse" aria-expanded="false" style="">
                                                        <div class="card-body ">
                                                            <span v-if="item.components.length == 0" v-html="item.content"></span>
                                                            <template v-for="(subitem,subindex) in item.components" >
                                                                <span v-if="subitem.typeId == 1" v-html="subitem.content" :key="subindex" ></span>
                                                                <div v-else class="sub-card">
                                                                    <a href="javascript:void(0);" data-level="3" data-toggle="collapse" :data-target="'#collapseinnerdeeper-'+ subindex" aria-expanded="false" :aria-controls="'collapseinnerdeeper-'+ subindex" class="btn-link  collapsed">
                                                                        <div id="headingtwo" class="card-header">
                                                                            <img class="icon" src="images/document.svg">
                                                                            <h3 class="question">{{subitem.title}} </h3>
                                                                            <span class="more">&lsaquo;</span>
                                                                        </div>
                                                                    </a>
                                                                    <div :id="'collapseinnerdeeper-'+ subindex" data-level="3" aria-labelledby="headingtwo" data-parent="#accordionpage" class="collapseinnerdeeper collapse" aria-expanded="false" style="">
                                                                        <div class="card-body">
                                                                             <span v-html="subitem.content"></span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="line-left"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
          <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" :href="'backend/hito-vida/'+ step.hitoId + '/etapa/' + step.stage_hito_vida_id +'/pasos'">Cancelar</a>
                <button type="submit" class="btn btn-primary" v-show="data.components.length > 0">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
.card p{
    font-size: 16px!important;
}

.sectionform{
    background-color: #F7F7F7;
    padding-top: 20px;
}
.border{
    background: #F7F7F7;
    border: 1px solid #F7F7F7;
    border-radius: 4px;
    display: block;
    padding-top: 14px;
    margin-bottom: 7px;
    padding-right: 7px;
}

.subcardForm{
    background-color: #e8f0fe;
    margin: 10px;
}

.content .know-more a{
    position: relative !important;    
}



.content .know-more.page-link {
    border: solid 1px #db443c;
    border-radius: 8px;
    padding: 20px 20px 20px 70px;
    background: #ffffff;
    position: relative !important;
    text-decoration: underline;
    display: inline-block;
}

.content .know-more.page-link img {
    color: #ffffff !important;
    background: #db443c;
    padding: 15px;
    position: absolute;
    border-radius: 7px;
    left: 0;
    top: 0;
    height: 100%;
    width: auto;
    min-width: 60px;
}
</style>
<script>

import Vue from 'vue';
import EditorHitoVida from "./EditorHitoVida.vue"; 
import { Message } from "element-ui";
import ElSwitch from 'element-ui/lib/switch';
import ElSelect from 'element-ui/lib/select';
import ElOption from 'element-ui/lib/option';
import { VueTreeList, Tree, TreeNode } from "vue-tree-list";
import locale from "element-ui/lib/locale/lang/es";

export default {

    data:function(){
        
        const data ={
            name:'',
            description:'',
            order:1,
            active:true,
            components:[]
        }
         _.assign(data, this.step);

    return {
            data:data,
            description:'',
            editComponent:false,
            editSubComponent:false,
            indexComponent:-1,
            indexSubComponent:-1,
            component:this.initComponent(),
            subcomponent:this.initComponent(),
            errors: {}
        }
    },
    props:['step','edit','typecomponents'],
    components:{
        EditorHitoVida,
        ElSwitch,
        VueTreeList,
        ElSelect,
        ElOption
    },
    watch:{
        description:function(d){
            var finaltext = '';
        
            finaltext = this.setIconLinkInfo(d,'info',0);

            finaltext = this.setIconLinkInfo(d,'docEditor',0);

            finaltext = this.addClassUlLii(finaltext,0);
            

            if(finaltext.length > 0){
                tinymce.activeEditor.setContent(finaltext);
                tinymce.activeEditor.focus();
                tinyMCE.activeEditor.selection.select(tinyMCE.activeEditor.getBody(), true);
                tinyMCE.activeEditor.selection.collapse(false);
            }
        }
    },
    methods:{
        initComponent:function(){
            return {
                        name: '',
                        typeId : '',
                        content: '',
                        title: '',
                        components:[]
                    };
        },
        addComponent:function(type){
            var self = this;
            var finaltext ='';            
            var element={};

            
            if(self.description.length > 0){
                finaltext = this.setIconLinkInfo( self.description,'info',0);
                finaltext = this.addClassUlLii(finaltext);
                finaltext = this.setToAddContentDocIcon(finaltext);
            }

          
            if(type == 'comp'){
                
                if(this.validateComponent()){
                    if(self.editComponent){
                        this.data.components[this.indexComponent].content = finaltext;
                        this.data.components[this.indexComponent].title =self.component.title;
                        this.data.components[this.indexComponent].components= self.component.components.length >0 ? self.component.components : [];
    
                        self.editComponent =false;
                    }
                    else{
                        element = {
                                    name: self.typecomponents.find(c=> c.id == self.component.typeId ).name,
                                    typeId : self.component.typeId,
                                    content: finaltext,
                                    title: self.component.title,
                                    components:self.component.components.length >0 ? self.component.components : []
                                };
        
                        this.data.components.push(element);    
                    }
                    self.component = this.initComponent();
                }
            }
            else{
                if(this.validateComponent()){
                    if(this.editSubComponent)
                   {
                        this.component.components[this.indexSubComponent].title =self.subcomponent.title;
                        this.component.components[this.indexSubComponent].content = finaltext;
                        this.editSubComponent =false;
                    }
                    else{
                        element = {
                                    name: self.typecomponents.find(c=> c.id == self.subcomponent.typeId ).name,
                                    typeId : self.subcomponent.typeId,
                                    content: finaltext,
                                    title: self.subcomponent.title,
                                    components:[]
                                };
                        this.component.components.push(element);
    
                    }
                    self.subcomponent = this.initComponent();
                }
                    
            }
               
            self.description= '';
            tinymce.activeEditor.setContent(self.description);

        },
        onEditComponent:function(index){
            
            if(!this.editComponent){
                this.editComponent =true;
                this.indexComponent = index;
            }
            else{
                if(this.indexComponent == index){
                    this.editComponent = false;
                    this.indexComponent = -1;
                }
                else{
                    this.editComponent =true;
                    this.indexComponent = index;
                }
            }

            if(this.editComponent){
                this.component = this.initComponent();
                this.component.name = this.data.components[index].name;
                this.component.typeId = this.data.components[index].typeId;
                this.description = this.data.components[index].content;
                this.component.title = this.data.components[index].title;
                this.component.components = this.data.components[index].components;

                
            }
            else{
                this.component = this.initComponent();
                this.subcomponent = this.initComponent();
                this.description ='';
                tinymce.activeEditor.setContent('');
            }
       
        },
        onEditSubComponent: function(index){

            if(!this.editSubComponent){
                this.editSubComponent = true;
                this.indexSubComponent= index;
            }
            else{
                if(this.indexComponent == index){
                    this.editSubComponent = false;
                    this.indexSubComponent = -1;
                }
                else{
                    this.editSubComponent = true;
                    this.indexSubComponent= index;
                }
            }

            if(this.editSubComponent){
                this.subcomponent = this.initComponent();
                this.subcomponent.name = this.component.components[index].name;
                this.subcomponent.typeId = this.component.components[index].typeId;
                this.description = this.component.components[index].content;
                this.subcomponent.title = this.component.components[index].title;
            }else{
                this.subcomponent = this.initComponent();
            }

           

        },
        deleteComponent:function(index){
            var self = this;

            self.$confirm('¿Está seguro de eliminar el componente?','Atención',{
                confirmButtonText:'Eliminar',
                cancelButtonText: 'Cancelar',
                type:'warning'
            }).then(()=>{
                this.data.components.splice(index,1);

                if(this.data.components.length == 0){
                    this.cancelComponent();
                }
            }).catch();
             
        },
        deleteSubComponent: function(index){
            var self = this;

            self.$confirm('¿Está seguro de eliminar el componente?','Atención',{
                confirmButtonText:'Eliminar',
                cancelButtonText: 'Cancelar',
                type:'warning'
            }).then(()=>{
                this.component.components.splice(index,1);

                if(this.component.components.length ==0){
                    this.subcomponent = initComponent();
                }

            }).catch();
        },
        upComponent:function(from){
            if(from == 0)
                return;
            
            var to = from -1;
 
            this.data.components.splice(to,0,this.data.components.splice(from,1)[0]);
 
        },
        downComponent:function(from){
            var to = from +1;
            var pos =1 ;

            this.data.components.splice(to,0,this.data.components.splice(from,1)[0]);
        },
        upSubComponent:function(from){
            if(from == 0)
                return;
            
            var to = from -1;
 
            this.component.components.splice(to,0,this.component.components.splice(from,1)[0]);
 
        },
        downSubComponent:function(from){
            var to = from +1;
            var pos =1 ;

            this.component.components.splice(to,0,this.component.components.splice(from,1)[0]);
        },
        addElement:function(type){
            var link ='';

            if(type == 'card'){
                this.subcardEditor=true;
            }
            else{
                switch(type){
                    case 'info': link= '<a class="know-more clear" href="#"><img src="images/bullet-info.svg" />Edite el link</a><p></p>'; 
                                break;
                    case 'doc': link= '<a class="know-more page-link clear" href="#">Edite el link archivo</a><p></p>'; 
                                break;
                }
                this.description = this.description + link;
                tinymce.activeEditor.setContent(this.description );
            }

        },
        setIconLinkInfo:function(content,type,pos){
            var length = content.length;
            var posIniTag = 0;
            var posEndTag =0;
            var posIcon = 0;
            var finalContent ='';

            switch(type){
                case 'info': posIniTag = content.indexOf('know-more clear',pos);
                            break;
                case 'doc': posIniTag = content.indexOf('know-more page-link clear',pos);
                            break;
                case 'docEditor': posIniTag = content.indexOf('know-more page-link clear',pos);
                            break;
            }
            
            if(posIniTag > -1){
                posEndTag = content.indexOf('>',posIniTag);

                switch(type){
                    case 'info': posIcon = content.indexOf('<img src="images/bullet-info.svg" />',posEndTag);
                                break;
                    case 'doc': posIcon = content.indexOf('<img src="images/doc.svg" />',posEndTag);
                                break;
                    case 'docEditor':   posIcon = content.indexOf('<em class="material-icons">description</em>',posEndTag);
                                        break;
                }

                if(posIcon == -1){
                    switch(type){
                        case 'info':    finalContent = content.slice(0,posEndTag +1) +'<img src="images/bullet-info.svg" />' + finalContent + content.slice(posEndTag + 1 , length) ;
                                        posIcon = finalContent.indexOf('<img src="images/bullet-info.svg" />',posEndTag +1);
                                        this.setIconLinkInfo(finalContent,posIcon);
                                        break;
                        case 'doc':     finalContent = content.slice(0,posEndTag +1) +'<img src="images/doc.svg" />' + finalContent + content.slice(posEndTag + 1 , length) ;
                                        posIcon = finalContent.indexOf('<img src="images/doc.svg" />',posEndTag +1);
                                        this.setIconLinkInfo(finalContent,posIcon);
                                        break;
                        case 'docEditor':     
                                        
                                        finalContent = content.slice(0,posEndTag +1) +'<em class="material-icons">description</em>' + finalContent + content.slice(posEndTag + 1 , length) ;
                                        posIcon = finalContent.indexOf('<em class="material-icons">description</em>',posEndTag +1);
                                        this.setIconLinkInfo(finalContent,posIcon);
                                        break;
                    }
                   
                }else{
                    finalContent =content; 
                }
 
            }else{
                finalContent =content; 
            }

            finalContent = finalContent.replace(/<p><a/gi,'<a');
            
            return finalContent;
        },
        setToAddContentDocIcon: function(content){
            return content.replace(/<em class="material-icons">description<\/em>/gi,'<img src="images/doc.svg" />');
        },
        setToEditorDocIcon:function(content){
            return content.replace(/<img src="images\/doc.svg" \/>/ ,'');
        },
        addClassUlLii: function(content){
            var finalContent ='';

            finalContent = content.replace(/<ul>/gi,'<ul class="stage-list">');
            finalContent = finalContent.replace(/<li>/gi,'<li><span>');
            finalContent = finalContent.replace(/<\/li>/gi,'</span></li>');

            // clean
            finalContent = finalContent.replace(/<span><span>/gi,'<span>');
            finalContent = finalContent.replace(/<\/span><\/span>/gi,'</span>');
            return finalContent;
        },
        setFinalText:function(content){
            var self = this;
            var finaltext ='';

            if(content.length >0){
                finaltext = this.setIconLinkInfo( self.description,'info',0);
                finaltext = this.addClassUlLii(finaltext);
                finaltext = this.setToAddContentDocIcon(finaltext);
            } 

            return  finaltext;
        },
        cleaEditor: function(){
            this.errors={};

            if(this.subcomponent.typeId == ''){
                this.description ='';
            }
        },
        validateComponent: function(){
            this.errors={};

            if(this.component.typeId == 2 ){
                if(this.component.title.length == 0  ){
                    this.errors['title'] = ['Debe indicar un titulo a la tarjeta'];
                }

                if(this.subcomponent.typeId == 2 && this.subcomponent.title.length == 0  ){
                    this.errors['subcomponenttitle'] = ['Debe indicar un titulo a la sub tarjeta'];
                }
            }
    
            if((this.component.typeId  == 1 && this.description.length == 0) || (this.component.typeId == 2 && this.subcomponent.typeId >0  && this.description.length == 0)){
                this.errors['description'] = ['Debe ingresar texto a la descripción'];
            }

            if(_.values(this.errors).length == 0){
                return true;
            }else{
                return false;
            }
        },
        cancelComponent:function(){
            this.description ='';
            this.component = this.initComponent();
            this.subcomponent  = this.initComponent();
            this.editComponent =false;
        },
        submit: function(){
            this.errors={};

            if(this.data.name.length == 0){
                this.errors['name']= ['Debe ingresar el nombre'];
            }

          
            if(_.values(this.errors).length == 0){

                axios({
                    url: this.edit? 'backend/hito-vida/etapa/pasos/update': 'backend/hito-vida/etapa/pasos/store',
                    method: this.edit? 'PUT':'POST',
                    data: this.data,
                }).then(function(response){
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    self.errors = error.response.data.errors;
                });
            } 

        }
    }
}
</script>